<template>
  <div class="project-wrapper">
    <div class="project-container">
      <div class="project-content">
        <p class="project-current-step">{{ Translator('soprasolar.project.resume.step') }}</p>
        <h1 class="project-title">{{ Translator('soprasolar.project.resume.title') }}</h1>
      </div>
      <div class="project-content">
        <resume />
      </div>
    </div>
    <div class="project-footer">
      <div class="project-actions">
        <button type="button" class="button-flat" @click="onNext" :disabled="isLoading">
          {{ Translator('soprasolar.project.end') }}
          <i class="ic ic-arrow-right"></i>
          <span class="button-loader" v-if="isLoading"></span>
        </button>
        <button type="button" class="button-link" @click="onPrevious">
          <i class="ic ic-arrow-left"></i>
          {{ Translator('soprasolar.project.previous') }}
        </button>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
@import "~@/soprasolar-project/assets/styles/import";
.project-wrapper {
  @include vertical-spacing-inner-top;
}
</style>
<script>
import AppControlService from '@/soprasolar-project/services/AppControl';
import Resume from '@/soprasolar-project/components/Resume';

export default {
  name: 'final',
  components: {
    Resume
  },
  data () {
    return {
      isLoading: false,
      datas: AppControlService.datas,
      files: []
    }
  },

  created() {
    AppControlService.on('datas', this._onUpdateDatas);
  },

  beforeDestroy() {
    AppControlService.off('datas', this._onUpdateDatas);
  },

  mounted() {},

  methods: {
    onPrevious() {
      AppControlService.goToPrevStep();
    },

    onNext() {
      AppControlService.finish().then( () => {
        AppControlService.goToNextStep();
      }).catch(console.error).then(() => {
        this.isLoading = false;
      })
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },

    _onUpdateDatas(datas) {
      this.datas = datas;
    }
  }
};
</script>